<div class="table-ctn" *transloco="let t">
  <div class="box-title">{{ t("sov-main-table.brands") }}</div>
  <div class="brands-wrapper">
    @if (!loading) {
      <div class="search-brand-bar flex items-center justify-between">
        <input
          class="px-3 py-3"
          autocomplete="off"
          type="text"
          placeholder="{{ t('sov-main-table.search_brands') }}"
          [formControl]="filter"
        />
        <IIcon name="search" class="mr-3" />
      </div>
      <div class="brand-list">
        @if (userBrands && userBrands.length) {
          <div class="user-brands">
            @for (b of userBrands; track b) {
              <div
                class="brand-item"
                [class.selected]="isBrandSelected(b) > -1"
                (click)="toggleBrandSelection(b)"
                (mouseenter)="brandMouseEnter(b)"
                (mouseleave)="brandMouseLeave()"
              >
                <div class="index">{{ (allBrands?.indexOf(b) ?? 0) + 1 }}</div>
                <div class="brand-item-name truncate">{{ b }}</div>
                <div class="ml-auto inline-flex items-center">
                  <div
                    class="color-badge ml-3"
                    [style.background-color]="isBrandSelected(b) > -1 ? brandColors?.get(b) : '#cccccc'"
                  ></div>
                  <span
                    [iTooltip]="t('sov-main-table.select_only_this_brand')"
                    (click)="toggleBrandSelection(b, true); $event.stopPropagation()"
                  >
                    <IIcon name="ellipsisVertical" class="ml-4 text-sm" />
                  </span>
                </div>
              </div>
            }
          </div>
        }
        @for (b of filteredBrands; track b) {
          <div
            class="brand-item"
            [class.selected]="isBrandSelected(b) > -1"
            (click)="toggleBrandSelection(b)"
            (mouseenter)="brandMouseEnter(b)"
            (mouseleave)="brandMouseLeave()"
          >
            <div class="index">{{ (allBrands?.indexOf(b) ?? 0) + 1 }}</div>
            <div class="brand-item-name truncate">{{ b }}</div>
            <div class="ml-auto inline-flex items-center">
              <div
                class="color-badge ml-3"
                [style.background-color]="isBrandSelected(b) > -1 ? brandColors?.get(b) : '#cccccc'"
              ></div>
              <span
                [iTooltip]="t('sov-main-table.select_only_this_brand')"
                (click)="toggleBrandSelection(b, true); $event.stopPropagation()"
              >
                <IIcon name="ellipsisVertical" class="ml-4 text-sm" />
              </span>
            </div>
          </div>
        }
      </div>
    } @else {
      <div class="flex h-full items-center justify-center">
        <ISpinner [display]="true" />
      </div>
    }
  </div>
</div>
